export default "__VITE_ASSET__5af52e01__"